import React from 'react'

export const ReadQR = () => {
  return (
    <div>ReadQR</div>
  )
}
